exports.components = {
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-play-jsx": () => import("./../../../src/pages/play.jsx" /* webpackChunkName: "component---src-pages-play-jsx" */)
}

